// Ventana de las acciones de una jornada (pestaña Líneas y menús del formato
// nuevo). Sin portal ni recorte del contenido: el desplegable de direcciones
// de Google se ve entero y, en un móvil, la ventana entera se desplaza.
import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import useEsMovil from '../../hooks/useEsMovil';

export const claseCampoJornada = 'w-full h-11 md:h-10 px-3 text-base md:text-sm border border-[#CBD3CF] rounded-lg text-[#16221D] focus:outline-none focus:ring-2 focus:ring-duetto-primary';
export const claseEtiquetaJornada = 'flex flex-col gap-1 text-xs font-semibold text-[#5B6B64]';
export const claseBotonPrincipal = 'h-11 md:h-10 px-4 rounded-lg bg-duetto-primary text-white text-sm font-semibold hover:bg-opacity-90 disabled:opacity-50';
export const claseBotonSecundario = 'h-11 md:h-10 px-4 rounded-lg border border-[#CBD3CF] bg-white text-sm font-semibold text-[#16221D] hover:bg-gray-50 disabled:opacity-50';

const ModalJornada = ({ titulo, subtitulo = null, onCerrar, children, pie = null, ancho = 'max-w-lg', testid }) => {
  const esMovil = useEsMovil();
  useEffect(() => {
    const alPulsar = (e) => { if (e.key === 'Escape' && onCerrar) onCerrar(); };
    window.addEventListener('keydown', alPulsar);
    return () => window.removeEventListener('keydown', alPulsar);
  }, [onCerrar]);

  // Móvil (< 768 px): pantalla completa, sin redondeo, un solo desplazamiento
  // (el de la ventana) y el pie pegado abajo con botones de 44 px
  if (esMovil) {
    return (
      <div className="fixed inset-0 z-50 bg-white overflow-y-auto" data-testid={testid}>
        <div className="min-h-full flex flex-col" role="dialog" aria-modal="true" aria-label={titulo}
          data-testid="modal-jornada-movil">
          <div className="sticky top-0 z-10 bg-white px-4 py-3 border-b border-[#E1E6E3] flex items-start justify-between gap-3">
            <div className="min-w-0">
              <h3 className="text-base font-bold text-[#16221D]">{titulo}</h3>
              {subtitulo && <p className="text-[13px] text-[#5B6B64] mt-0.5">{subtitulo}</p>}
            </div>
            <button
              type="button"
              onClick={onCerrar}
              className="w-11 h-11 -mr-2 -mt-1 flex items-center justify-center rounded-full text-[#5B6B64] active:bg-gray-100"
              aria-label="Cerrar"
              data-testid="modal-jornada-cerrar-movil"
            >
              <X className="w-6 h-6" />
            </button>
          </div>
          <div className="flex-1 px-4 py-4 flex flex-col gap-3">{children}</div>
          {pie && (
            <div className="sticky bottom-0 bg-white px-4 py-3 border-t border-[#E1E6E3] flex flex-wrap justify-end gap-2 [&>button]:h-11 [&>button]:flex-1 [&>button]:min-w-[8rem]"
              style={{ paddingBottom: 'max(0.75rem, env(safe-area-inset-bottom))' }}>
              {pie}
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div
      className="fixed inset-0 z-50 bg-black/50 overflow-y-auto"
      onMouseDown={(e) => { if (e.target === e.currentTarget && onCerrar) onCerrar(); }}
      data-testid={testid}
    >
      <div className="min-h-full flex items-start sm:items-center justify-center p-4">
        <div className={`w-full ${ancho} bg-white rounded-xl shadow-xl`} role="dialog" aria-modal="true" aria-label={titulo}>
          <div className="px-4 sm:px-5 py-3.5 border-b border-[#E1E6E3] flex items-start justify-between gap-3">
            <div className="min-w-0">
              <h3 className="text-base font-bold text-[#16221D]">{titulo}</h3>
              {subtitulo && <p className="text-xs text-[#5B6B64] mt-0.5">{subtitulo}</p>}
            </div>
            <button
              type="button"
              onClick={onCerrar}
              className="p-1.5 rounded-full text-[#5B6B64] hover:bg-gray-100"
              aria-label="Cerrar"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
          <div className="px-4 sm:px-5 py-4 flex flex-col gap-3">{children}</div>
          {pie && (
            <div className="px-4 sm:px-5 py-3 border-t border-[#E1E6E3] flex flex-wrap justify-end gap-2">{pie}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalJornada;
